import { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Text } from '@artprov/design-system'
import Sentry from '@/common/utils/middleware/config.sentry.js'

export default class MicrofrontendBoundary extends Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, {
      contexts: {
        microfrontend: {
          name: this.props.name,
          componentStack: errorInfo.componentStack,
        },
      },
    })
  }

  render() {
    if (!this.state.error) {
      return <div className="w-full">{this.props.children}</div>
    }

    return (
      <section className="flex min-h-64 flex-col items-center justify-center gap-4 text-center" role="alert">
        <Text variant="h6">No pudimos cargar {this.props.name}.</Text>
        <Text variant="body1">Verificá que la aplicación esté disponible e intentá nuevamente.</Text>
        <Button type="button" onClick={this.props.onRetry}>
          Reintentar
        </Button>
      </section>
    )
  }
}

MicrofrontendBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  onRetry: PropTypes.func.isRequired,
}
